module.exports = __webpack_public_path__ + "static/media/03.330cdef6.webp";